import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  workspace_name: "Youngness · Awish R&D",
  brands: ["Youngness Center", "Awish Clinic", "Both"],
  idea_categories: ["Device/Machine", "Clinical Service", "Cosmetic/Formulation", "Biotech/Paper", "Digital/Software"],
  goal_categories: ["New Service Launch", "Tech Acquisition", "Quality/Safety Upgrade", "Ingredient Sourcing", "Revenue Impact"],
  researchers: ["Dr. Lena Voss", "Dr. Omar Reyes", "Priya Nair"],
  rejection_reasons: ["High Cost", "Low Efficacy", "Regulatory Issue", "Irrelevant"],
  default_date_range: "all",
  default_landing: "/",
};

const Ctx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    api.get("/settings")
      .then((r) => { setSettings({ ...DEFAULTS, ...r.data }); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const save = async (next) => {
    const { data } = await api.put("/settings", next);
    setSettings({ ...DEFAULTS, ...data });
    return data;
  };

  return <Ctx.Provider value={{ settings, loaded, refresh, save, setSettings }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
